// App.tsx
import { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { appRoutes } from '@/routes/app.router';
import { AuthProvider } from '@/contexts/AuthContext';
import { NotificationProvider } from '@/contexts/NotificationContext';
import { OrderProvider } from '@/contexts/OrderContext';
import { TrackingProvider } from '@/contexts/TrackingContext';
import { PropertyProvider } from '@/contexts/PropertyContext';
import { SearchProvider } from '@/contexts/SearchContext';
import { FavoritesProvider } from '@/contexts/FavoritesContext';
import { I18nProvider } from '@/contexts/I18nContext';
import { AlertProvider } from '@/contexts/AlertContext';
import { SidebarProvider } from '@/contexts/SidebarContext';
import ErrorBoundary from '@/components/ErrorBoundary';
import NativeMobileRouteGuard from '@/components/auth/NativeMobileRouteGuard';
import SubscriptionRenewalModal from '@/components/SubscriptionRenewalModal';
import { isNativeMobileApp } from '@/utils/mobileApp';

// Loading component
const Loading = () => (
  <div className="flex items-center justify-center h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C4A35A]"></div>
  </div>
);

function App() {
  const routeElement = useRoutes(appRoutes);

  return (
    <ErrorBoundary>
      <I18nProvider>
        <AuthProvider>
          <NotificationProvider pollingInterval={isNativeMobileApp() ? 60000 : 30000}>
            <AlertProvider>
              <FavoritesProvider>
                <OrderProvider>
                  <TrackingProvider>
                    <PropertyProvider>
                      <SearchProvider>
                        <SidebarProvider>
                          <NativeMobileRouteGuard>
                            <Suspense fallback={<Loading />}>
                              {routeElement}
                            </Suspense>
                            <SubscriptionRenewalModal />
                          </NativeMobileRouteGuard>
                        </SidebarProvider>
                      </SearchProvider>
                    </PropertyProvider>
                  </TrackingProvider>
                </OrderProvider>
              </FavoritesProvider>
            </AlertProvider>
          </NotificationProvider>
        </AuthProvider>
      </I18nProvider>
    </ErrorBoundary>
  );
}

export default App;
